import { render, staticRenderFns } from "./CMUserResetPassword.vue?vue&type=template&id=dcc5a7b8&scoped=true&"
import script from "./CMUserResetPassword.vue?vue&type=script&lang=js&"
export * from "./CMUserResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./CMUserResetPassword.vue?vue&type=style&index=0&id=dcc5a7b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc5a7b8",
  null
  
)

export default component.exports